import { render } from "./BlurredNoPermissionPage.vue?vue&type=template&id=04851020&scoped=true&ts=true"
import script from "./BlurredNoPermissionPage.vue?vue&type=script&lang=ts"
export * from "./BlurredNoPermissionPage.vue?vue&type=script&lang=ts"

import "./BlurredNoPermissionPage.vue?vue&type=style&index=0&id=04851020&lang=scss"
import "./BlurredNoPermissionPage.vue?vue&type=style&index=1&id=04851020&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04851020"]])

export default __exports__